import type { ScheduleActivityItem } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/schedule_activity.pb';
import { Text, Truncated } from '@frontend/design-system';
import { formatDateByRecency } from '../../utils/date-helpers';
import { parseAiRequestDetails } from '../../views/Calendar/EventsPanel/ScheduleActions/ScheduleRequests/hooks/useGetScheduleRequest';

type Props = {
  row: ScheduleActivityItem;
  locationTimezone: string;
};

export const AppointmentTimeCellRenderer = ({ row, locationTimezone }: Props) => {
  if (!row?.appointmentTime && !row?.bookingDetails) {
    return <Text size='medium'>-</Text>;
  }

  if (!!row.bookingDetails) {
    const aiRequestDetails = parseAiRequestDetails(row.bookingDetails);
    const preferredTimeText = aiRequestDetails?.schedulingPreferences?.requestedSlots?.[0]?.rawText;

    return (
      <Truncated as={Text} size='medium'>
        {preferredTimeText || ''}
      </Truncated>
    );
  }

  return formatDateByRecency(row.appointmentTime, locationTimezone);
};
